$ = require 'jquery'
_ = require 'underscore'
Alerts = require 'app/scripts/views/lib/alerts'
Auth = require 'app/scripts/db/auth'
Confirm = require 'app/scripts/views/lib/confirm'
ModelLoader = require 'app/scripts/db/model-loader.coffee'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
template = require 'app/scripts/views/templates/board_menu_email'
l = require 'app/scripts/lib/localize'

module.exports = class EditEmailSettingsView extends View
  viewTitleKey: 'add cards via email'

  initialize: ->
    super
    @listenTo @modelCache, 'add:List remove:List change:List:closed reset:List',
      @frameDebounce @render
    @listenTo @model, 'change:myPrefs', @frameDebounce @render

    @allowEmail = true

    if !@model.getPref('emailKey')?
      @model.generateEmailKey()

  events:
    'change .js-select-position': 'updatePosition'
    'change .js-select-list': 'updateList'
    'click .js-generate-address': 'generateAddress'
    'click .js-send-address': 'sendAddressEmail'
    'click .js-autofocus': 'focusInput'

  render: ->
    if @model.canComment(Auth.me())
      idSelectedList = @model.getPref('idEmailList')

      lists = @model.listList.models.map((list) -> id: list.id, name: list.get('name'))

      selectedListName =
        if (list =  _.findWhere(lists, id: idSelectedList))?
          list.name
        else if (list = @modelCache.get('List', idSelectedList))? && list.get('closed')
          archivedName = l('archived list', listName: list.get('name'))
          lists.unshift { id: list.id, name: archivedName }
          archivedName
        else
          if idSelectedList?
            # Load list into cache then rerender, grabbing it from cache.
            ModelLoader.loadArchivedLists(@model.id)
            .then =>
              # Only re-render if we actually found the list; if the list was
              # moved to another board, we're never going to find it
              if @modelCache.get('List', idSelectedList)?
                @render()
          l('unknown list placeholder')

      if !idSelectedList?
        lists.unshift({
          name: l('unknown list placeholder')
          selected: true
        })

      @$el.html(template({
        commentsEnabled: true
        email: @model.getPref('fullEmail') ? ''
        lists: lists.map (list) ->
          id: list.id
          name: list.name
          selected: list.id == idSelectedList
        listName: selectedListName
        positionName: l(['email position', @model.getPref('emailPosition')])
        position: @model.getPref('emailPosition')
      }))
    else
      @$el.html(template({
        commentsEnabled: false
      }))

    @

  focusInput: (e) ->
    $(e.target).focus().select()

    return

  updateValue: (selectName, prefName) ->
    val = @$el.find(selectName).val()

    if val? && (val != @model.getPref(prefName))
      @model.setPref(prefName, val)

  updatePosition: ->
    @updateValue('.js-select-position', 'emailPosition')

  updateList: ->
    @updateValue('.js-select-list', 'idEmailList')
    @allowEmail = true

  generateAddress: (e) ->
    Util.stop(e)

    Confirm.pushView 'regenerate email address',
      model: @model
      confirmBtnClass: 'negate'
      popOnClick: true
      fxConfirm: (e) =>
        @model.set
          'myPrefs/emailKey': null

        @allowEmail = true

        @model.generateEmailKey()

    return

  sendAddressEmail: (e) ->
    Util.stop(e)

    if !@allowEmail
      return

    @allowEmail = false
    @model.api {
      method: 'emailKey/message'
      type: 'post'
    }, (err) =>
      if !err
        Alerts.flash('email sent', 'confirm')
      else
        Alerts.show('could not send email', 'error', 'email', 5000)

    return
